export const URL_ICF_CERT = {
  ACC:
    'https://images.youracclaim.com/size/220x220/images/95a0de45-11fe-4e8d-8eaa-fa88d2ecfc0f/ACC_Visual.png',
  MCC:
    'https://images.youracclaim.com/size/220x220/images/2921c330-23f7-4b84-b696-718e4154f19d/MCC_Visual.png',
  PCC:
    'https://images.youracclaim.com/size/220x220/images/72584e50-2c56-4369-9e75-a6729845958b/PCC_Visual.png',
};
